// Dubai - full-dismantle deep cleaning (chemical overhaul).
const content = {
    slug: 'ac-deep-cleaning-overhaul',
    title: (c) => `AC Deep Cleaning Dubai from ${c.money(c.tables.chemicalOverhaul[0].wall)} | Full Dismantle`,
    description: (c) =>
        `Full-dismantle AC deep cleaning in Dubai from ${c.money(c.tables.chemicalOverhaul[0].wall)}. The unit is taken down and every part washed - for neglected, mouldy or noisy units.`,
    eyebrow: 'Dubai · AC deep cleaning',
    h1: 'AC Deep Cleaning (Full Dismantle) in Dubai',
    lead: (c) =>
        `For a unit that has gone years without proper care. The technician takes the indoor unit off the wall, strips it down and washes every part separately - ${c.money(c.tables.chemicalOverhaul[0].wall)} for one split unit.`,
    image: 'blog/living/air-conditioner-blower.jpg',
    imageAlt: 'AC blower wheel removed for a full-dismantle deep clean',
    facts: ['Unit fully dismantled', 'Best for neglected units', '2-3 hours per unit'],
    priceTitle: 'Deep cleaning prices',
    priceIntro: 'Priced per unit. Split units are the usual candidates; ducted units can be overhauled too but take most of a day.',
    panel: { type: 'servicing', services: ['chemicalOverhaul'], defaultMount: 'Wall' },
    sections: [
        {
            title: 'When a coil wash is not enough',
            paragraphs: [
                'A chemical wash cleans the coil and blower where they sit. That works for most units. But in a split unit that has run several Dubai summers without a proper clean, dirt and mould also cake the inside of the casing, the back of the coil against the wall and the drain tray hidden behind the front panel - places a technician cannot reach without taking the unit down.',
                'You usually find these units in older Deira, Bur Dubai and Karama flats, in a newly rented apartment where nobody knows the service history, or in a guest room that was shut for a summer.',
            ],
        },
        {
            title: 'Signs you need the full dismantle',
            tone: 'muted',
            items: [
                'The smell comes back within weeks of a chemical wash.',
                'Black mould is visible on the blower blades when you shine a torch into the outlet.',
                'The unit rattles or the blower wobbles.',
                'Water collects inside the casing rather than draining away.',
                'You cannot remember when it was last serviced - and neither can the landlord.',
            ],
        },
        {
            // Target of the hero card's Service Details link
            id: 'included',
            title: 'How the job is done',
            steps: [
                { title: 'Unit taken down', body: 'The indoor unit is lifted off its mounting plate with the pipes still connected, so the gas stays sealed in the system.' },
                { title: 'Stripped to parts', body: 'Front panel, casing, drain tray and blower wheel are removed and washed separately with coil cleaner and degreaser.' },
                { title: 'Coil washed both sides', body: 'The coil is cleaned from the back as well as the front - the side a normal wash never reaches.' },
                { title: 'Reassembled and tested', body: 'The unit goes back on the wall, the drain is flushed and the technician checks airflow and temperature.' },
            ],
        },
    ],
    faqs: [
        {
            question: 'How much does a full AC deep cleaning cost in Dubai?',
            answer: (c) => `${c.money(c.tables.chemicalOverhaul[0].wall)} for one split unit and ${c.money(c.tables.chemicalOverhaul[1].wall)} for two. Ducted units start at ${c.money(c.tables.chemicalOverhaul[0].ducted)}.`,
        },
        {
            question: 'Does a deep clean affect the gas?',
            answer: 'No. The indoor unit is moved with its pipes still connected, so the refrigerant stays sealed. If the pressure is low for another reason, the technician tells you.',
        },
        {
            question: 'How often is a full dismantle needed?',
            answer: 'Rarely - once every two or three years for a unit that is otherwise cleaned regularly. If you need it every year, the routine cleaning schedule is too thin.',
        },
        {
            question: 'Is it worth it on an old unit?',
            answer: 'If the compressor and fan motor are healthy, yes - a deep clean often restores most of the lost cooling. If the unit is very old and uses R22 gas, the technician may suggest pricing a replacement instead.',
        },
    ],
    schema: {
        name: 'AC Deep Cleaning (Full Dismantle) in Dubai',
        serviceType: 'Air conditioner chemical overhaul',
        offers: (c) => [
            { name: 'Deep cleaning, 1 split unit', price: c.tables.chemicalOverhaul[0].wall },
            { name: 'Deep cleaning, 2 split units', price: c.tables.chemicalOverhaul[1].wall },
            { name: 'Deep cleaning, 1 ducted unit', price: c.tables.chemicalOverhaul[0].ducted },
        ],
    },
}

export default content
